import {
  type CorpusSettings,
  resolveCorpusSettings,
} from "@-/dev.improve.haniverse.lib.morpheme.corpus.settings";
import {
  createMorphemeCorpusFilter,
  type MorphemeCorpusFilter,
} from "@-/dev.improve.haniverse.lib.morpheme.corpus";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { useMemo } from "react";

/**
 * The user's browsing corpus for their active script (see `corpus_settings` on the actor `user`
 * row). Referentially stable until the script or the settings change, so it is safe to put in
 * query keys and dependency arrays. Only NON-curated surfaces should consult it: the curriculum,
 * decks and a morpheme's own detail page ignore it.
 */
export function useMorphemeCorpusFilter(): MorphemeCorpusFilter {
  const { corpusSettings, hanziScript } = useActorUser();
  // The cached row is parsed JSON, so compare by content: an unchanged row must not rebuild the
  // filter (and re-key every query that depends on it). Resolve first — a row cached before the
  // column existed has no `corpusSettings` at all.
  const corpusSettingsKey = JSON.stringify(resolveCorpusSettings(corpusSettings));
  return useMemo(
    () =>
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion -- round-trip of the resolved settings serialized just above
      createMorphemeCorpusFilter(hanziScript, JSON.parse(corpusSettingsKey) as CorpusSettings),
    [corpusSettingsKey, hanziScript],
  );
}
